<template>
  <div class="mt-2 mb-5 border-l-2 border-blue-500 pl-3">
    <h4 class="font-trebuchet-pixel uppercase text-xs font-semibold">{{ education.degree }}</h4>
    <p class="font-trebuchet-pixel font-medium text-xs">{{ education.institution }} | {{ education.year }}</p>
    <p v-if="education.description" class="font-trebuchet-pixel text-xs text-gray-700 mt-1">{{ education.description }}</p>

    <div v-if="education.mainSubjects && education.mainSubjects.length > 0" class="mt-2">
      <p class="font-trebuchet-pixel text-xxs font-semibold mb-1">{{ $t('windows.cv.mainSubjects') }}:</p>
      <ul class="list-disc list-inside text-xxs ml-2 space-y-1 text-gray-700">
        <li v-for="subject in education.mainSubjects" :key="subject">{{ subject }}</li>
      </ul>
    </div>

    <div v-if="education.rncpLink" class="mt-2">
      <a :href="education.rncpLink" target="_blank" class="text-xxs text-blue-600 underline">{{ $t('windows.cv.viewRNCP') }}</a>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  education: Object
})
</script>
